import React from 'react';

const LoadingCell = ({ className = "" }) => {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% { 
            background-position: -200% 0; 
          }
          100% { 
            background-position: 200% 0; 
          }
        }
        .shimmer {
          background: linear-gradient(90deg, 
            rgba(255, 255, 255, 0.05) 0%, 
            rgba(255, 255, 255, 0.15) 50%, 
            rgba(255, 255, 255, 0.05) 100%
          );
          background-size: 200% 100%;
          animation: shimmer 2s infinite;
        }
      `}</style>
      <div className={`flex justify-between items-center w-full h-[110px] px-6 py-3 ${className}`}>
        <div className="flex justify-start items-center self-stretch relative gap-[21px]">
          {/* Shimmer thumbnail */}
          <div className="flex-grow-0 flex-shrink-0 w-[67px] h-[67px] relative overflow-hidden rounded-xl bg-white/10 shimmer" />
          
          {/* Shimmer text lines */}
          <div className="flex flex-col justify-center items-start flex-grow-0 flex-shrink-0 w-[230px] relative gap-3">
            <div className="flex-grow-0 flex-shrink-0 w-[100px] h-2 rounded-[100px] bg-white/10 shimmer" />
            <div className="flex-grow-0 flex-shrink-0 w-[200px] h-2 rounded-[100px] bg-white/10 shimmer" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingCell;